/* SCRIPTS */

$(document).ready(function () {
  $(".c-team-detail__img").click(function () {
    console.log("click");
    $(".c-team-detail__img").removeClass("c-team-detail__img--active");
    $(".c-team-detail__text").removeClass("c-team-detail__text--active");
    $(this).addClass("c-team-detail__img--active");
    $(this)
      .next(".c-team-detail__text")
      .addClass("c-team-detail__text--active");
    $(".c-team-detail__content").addClass("c-team-detail__content--active");
  });

  // SLICK

  $('.js-insta-slick').slick({
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 765,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  /* GDPR */

  $("#gdpr-link").click(function (e) {
    e.preventDefault();
    $("#gdpr-container, .c-gdpr__inner").addClass("visible");
  });

  $(".c-gdpr__background, .c-gdpr__close").click(function (e) {
    e.preventDefault();
    $("#gdpr-container, #gdpr-container-2, .c-gdpr__inner").removeClass(
      "visible"
    );
  });

  $("#gdpr-link-2").click(function (e) {
    e.preventDefault();
    $("#gdpr-container-2, .c-gdpr__inner").addClass("visible");
  });

  /* HERO AREA VIDEO */

  if ($(".o-video").length) {
    var thumb = $(".o-video").attr("data-src-thumb");

    var extension = thumb.substr(thumb.length - 3);
    if (extension == "jpg" || extension == "png") {
      $(".o-video").html("<img src='" + thumb + "' alt=''>");
    } else {
      $(".o-video").html(
        "<video width='100%' height='100%' loop preload autoplay muted><source src='" +
          thumb +
          "'></video>"
      );
    }

    $(".o-video").click(function () {
      $(".o-video__full").addClass("visible");
      var full = $(".o-video").attr("data-src-full");
      $(".o-video__container").html(
        "<video width='100%' height='100%' loop preload controls id='hero-video'><source src='" +
          full +
          "'></video>"
      );
    });

    $(".o-video__background, .o-video__close").click(function (e) {
      e.preventDefault();
      $(".o-video__full").removeClass("visible");
      $("#hero-video").trigger("pause");
    });
  }

  /* FILE INPUT */

  $(".o-file-input").change(function () {
    if ($(".o-file-input")[0].files[0]) {
      $(".o-file-input__label").addClass("inserted").text("Soubor vložen");
      $(".o-file-input__name")
        .text($(".o-file-input")[0].files[0].name)
        .fadeIn();
    } else {
      $(".o-file-input__label").addClass("inserted").text("Vložit soubor");
      $(".o-file-input__name").text("").fadeOut();
    }
  });

  /* PUPUP */

  if (Cookies.get("cookie-info-popup") != "1") {
    $("#info-popup").addClass("visible");
  }

  $("#info-popup-close").click(function (e) {
    e.preventDefault();
    Cookies.set("cookie-info-popup", "1", { expires: 7, path: "" });
    $("#info-popup").removeClass("visible");
  });

  $(document).on("click", ".js-popup-close", function () {
    console.log("click");
    $(".js-popup").removeClass("visible");
  });

  /* Promo */

  $(document).on(
    "click",
    ".c-promo__button, .c-promo__back-button",
    function (e) {
      e.preventDefault();
      $(".c-promo").toggleClass("c-promo--open");
    }
  );

  /* Animations */

  function initAnimation() {
    if ($("#bodymovin-promo").length) {
      $("#bodymovin-promo").empty();
      var animation = lottie.loadAnimation({
        wrapper: document.getElementById("bodymovin-promo"),
        animType: "html",
        loop: false,
        prerender: true,
        autoplay: false,
        path: "/wp-content/themes/inveo/animations/promo/data.json",
      });
      animation.play();
    }
  }

  initAnimation();

  /* Scroll */

  $("#lp-button").click(function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#lp-form").offset().top,
      },
      2000
    );
  });
});

/* DoDo B2B Scripts */

$(document).ready(function () {
  // COOKIES

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  $(document).on("click", "#close-cookies", function () {
    setCookie("gdpr_consent", "agreed", 90);
    $("#cookies").removeClass("c-cookies--visible");
  });

  var cookie = getCookie("gdpr_consent");

  if (!cookie) {
    $("#cookies").addClass("c-cookies--visible");
  }

  // Language

  $(".current-lang").on("click", "a", function (e) {
    e.preventDefault();
    $(".js-lang-switch").toggleClass("c-header__lang-switch-list--open");
  });

  // Menu

  $("#main-menu-container .menu-item-has-children").each(function () {
    $('<div class="c-header__main-menu-arrow"></div>').appendTo($(this));
    var menuTitle = $(this).find("a").html();
    var subMenu = $(this).find(".sub-menu");
    $(
      '<li class="c-header__sub-menu-header"> <div class="c-header__sub-menu-arrow"></div>' +
        menuTitle +
        "</li>"
    ).prependTo(subMenu);
  });

  $(document).on("click", ".c-header__sub-menu-header", function () {
    $(this).parents(".sub-menu").removeClass("sub-menu--active");
  });

  $(document).on("click", ".c-header__main-menu-arrow", function () {
    $(this).prev(".sub-menu").addClass("sub-menu--active");
  });

  $(document).on("click", "#menu-switch", function (e) {
    e.preventDefault();
    $(this).toggleClass("c-header__hamburger--active");
    $("body").toggleClass("u-no-scroll");
    $(".sub-menu").removeClass("sub-menu--active");
    $("#menu-container").toggleClass("c-header__menu-outer--active");
  });

  // CITIES

  $(".js-cities-input").each(function () {
    var count = $(this).find("li").length;

    $(this).siblings(".js-cities-output").find("span").html(count);

    if (count <= 1) {
      $(this)
        .siblings(".js-cities-output")
        .find(".js-cities-in-multi, .js-cities-multi")
        .hide();
    } else {
      $(this)
        .siblings(".js-cities-output")
        .find(".js-cities-in-single, .js-cities-single")
        .hide();
    }
  });

  // MAP

  $(document).on("click", ".js-map-countries-link", function (e) {
    e.preventDefault();
    $(".js-map-countries-container").toggleClass(
      "js-map-countries-container-active"
    );
  });

  $(document).on("click", ".js-map-clickable", function () {
    if ($(this).attr("id") == "map_germany") {
      window.location.href = $("#map_id_DE").attr("href");
    }
    if ($(this).attr("id") == "map_czechia") {
      window.location.href = $("#map_id_CZ").attr("href");
    }
    if ($(this).attr("id") == "map_slovakia") {
      window.location.href = $("#map_id_SK").attr("href");
    }
    if ($(this).attr("id") == "map_poland") {
      window.location.href = $("#map_id_PL").attr("href");
    }
    if ($(this).attr("id") == "map_austria") {
      window.location.href = $("#map_id_AT").attr("href");
    }
    if ($(this).attr("id") == "map_hungary") {
      window.location.href = $("#map_id_HU").attr("href");
    }
    if ($(this).attr("id") == "map_bulgaria") {
      window.location.href = $("#map_id_BG").attr("href");
    }
  });

  // CHECK IF JOBS ARE LOADED

  (function () {
    var wait;
    var teamsLoaded = false;

    function checkJobs() {
      if ($(".cp-job__branch").length) {
        setTimeout(function () {
          if (teamsLoaded === false) {
            jsTeams();
            teamsLoaded = true;
          }
          colorItUp();
          filterJobs();
          showCouriers();
          clearInterval(wait);
        }, 50);
      } else if ($(".cp-message__text").length) {
        clearInterval(wait);
        emptyState();
      }
    }

    function waitForJobs() {
      wait = setInterval(checkJobs, 50);
    }

    waitForJobs();

    // EMPTY STATE

    function emptyState() {
      var visibleJobs = $(".cp-job:visible").length;

      if (visibleJobs == 0) {
        $("#capybara").hide();
        $(".js-no-jobs").show();
      }
    }

    // JOBS LIST

    function filterJobs() {
      if ($(".js-jobs-list-de").length) {
        $(".cp-job").each(function () {
          if (
            $(this).find(".cp-job__name").text().includes("Germany") ||
            $(this).find(".cp-job__name").text().includes("DE")
          ) {
            $(this).show();
          }
        });
      } else if ($(".js-jobs-list-hu").length) {
        $(".cp-job").each(function () {
          if (
            $(this).find(".cp-job__name").text().includes("Hungary") ||
            $(this).find(".cp-job__name").text().includes("HU")
          ) {
            $(this).show();
          }
        });
      } else if ($(".js-jobs-list-bg").length) {
        $(".cp-job").each(function () {
          if (
            $(this).find(".cp-job__name").text().includes("Bulgaria") ||
            $(this).find(".cp-job__name").text().includes("BG")
          ) {
            $(this).show();
          }
        });
      } else if ($(".js-jobs-list-sk").length) {
        $(".cp-job").each(function () {
          if (
            $(this).find(".cp-job__name").text().includes("Slovensko") ||
            $(this).find(".cp-job__name").text().includes("SK")
          ) {
            $(this).show();
          }
        });
      } else if ($(".js-jobs-list-at").length) {
        $(".cp-job").each(function () {
          if (
            $(this).find(".cp-job__name").text().includes("Austria") ||
            $(this).find(".cp-job__name").text().includes("AT")
          ) {
            $(this).show();
          }
        });
      } else if ($(".js-jobs-list-pl").length) {
        $(".cp-job").each(function () {
          if (
            $(this).find(".cp-job__name").text().includes("Poland") ||
            $(this).find(".cp-job__name").text().includes("PL")
          ) {
            $(this).show();
          }
        });
      }

      emptyState();
    }

    // CATEGORY COLORS

    function colorItUp() {
      $(".cp-job__branch").each(function () {
        if ($(this).text().includes("Marketing")) {
          $(this).addClass("cp-job__branch--marketing");
        } else if ($(this).text().includes("IS/IT")) {
          $(this).addClass("cp-job__branch--development");
        } else if ($(this).text().includes("Personalistika")) {
          $(this).addClass("cp-job__branch--hr");
        } else if ($(this).text().includes("Ekonomika")) {
          $(this).addClass("cp-job__branch--finance");
        } else if (
          $(this).text().includes("Doprava") &&
          $(this).siblings(".cp-job__profession").text().includes("Kurýr")
        ) {
          $(this).addClass("cp-job__branch--courier");
        } else if ($(this).text().includes("Operations")) {
          $(this).addClass("cp-job__branch--operations");
        } else if ($(this).text().includes("Projects")) {
          $(this).addClass("cp-job__branch--projects");
        } else if ($(this).text().includes("Q/A")) {
          $(this).addClass("cp-job__branch--quality");
        } else if ($(this).text().includes("Prodej")) {
          $(this).addClass("cp-job__branch--sales");
        } else if ($(this).text().includes("Administrativa")) {
          $(this).addClass("cp-job__branch--administrative");
        }
      });
    }

    $(document).on(
      "click",
      "#cp-filter .cp-button, .cp-detail__footer .cp-button--back",
      function () {
        waitForJobs();
      }
    );

    // TEAMS

    function showCouriers() {
      if ($(".js-jobs-list-courier").length) {
        $(".cp-filter__item--field").hide();
        $(".cp-job").each(function () {
          $(this).hide();
          if (
            $(this).find(".cp-job__branch").text().includes("Doprava") &&
            $(this).find(".cp-job__profession").text().includes("Kurýr")
          ) {
            $(this).show();
          }
        });
      }
    }

    function jsTeams() {
      if ($(".js-teams").length > 0) {
        var marketing = 0;
        var development = 0;
        var hr = 0;
        var finance = 0;
        var courier = 0;
        var fleet = 0;
        var operations = 0;
        var projects = 0;
        var quality = 0;
        var sales = 0;
        var administrative = 0;

        $(".cp-job__branch").each(function () {
          if ($(this).text().includes("Marketing")) {
            marketing++;
          } else if ($(this).text().includes("IS/IT")) {
            development++;
          } else if ($(this).text().includes("Personalistika")) {
            hr++;
          } else if ($(this).text().includes("Ekonomika")) {
            finance++;
          } else if (
            $(this).text().includes("Doprava") &&
            $(this).siblings(".cp-job__profession").text().includes("Kurýr")
          ) {
            courier++;
          } else if (
            $(this).text().includes("Doprava") &&
            !$(this).siblings(".cp-job__profession").text().includes("Kurýr")
          ) {
            fleet++;
          } else if ($(this).text().includes("Operations")) {
            operations++;
          } else if ($(this).text().includes("Projects")) {
            projects++;
          } else if ($(this).text().includes("Q/A")) {
            quality++;
          } else if ($(this).text().includes("Prodej")) {
            sales++;
          } else if ($(this).text().includes("Administrativa")) {
            administrative++;
          }
        });

        if (marketing == 1) {
          $(".js-teams-job-count-marketing")
            .text(marketing)
            .siblings(".js-teams-single-job")
            .show();
        } else if (marketing >= 2 && marketing <= 4) {
          $(".js-teams-job-count-marketing")
            .text(marketing)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-marketing")
            .text(marketing)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (development == 1) {
          $(".js-teams-job-count-dev")
            .text(development)
            .siblings(".js-teams-single-job")
            .show();
        } else if (development >= 2 && development <= 4) {
          $(".js-teams-job-count-dev")
            .text(development)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-dev")
            .text(development)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (hr == 1) {
          $(".js-teams-job-count-hr")
            .text(hr)
            .siblings(".js-teams-single-job")
            .show();
        } else if (hr >= 2 && hr <= 4) {
          $(".js-teams-job-count-hr")
            .text(hr)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-hr")
            .text(hr)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (finance == 1) {
          $(".js-teams-job-count-finance")
            .text(finance)
            .siblings(".js-teams-single-job")
            .show();
        } else if (finance >= 2 && finance <= 4) {
          $(".js-teams-job-count-finance")
            .text(finance)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-finance")
            .text(finance)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (courier == 1) {
          $(".js-teams-job-count-courier")
            .text(courier)
            .siblings(".js-teams-single-job")
            .show();
        } else if (courier >= 2 && courier <= 4) {
          $(".js-teams-job-count-courier")
            .text(courier)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-courier")
            .text(courier)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (fleet == 1) {
          $(".js-teams-job-count-fleet")
            .text(fleet)
            .siblings(".js-teams-single-job")
            .show();
        } else if (fleet >= 2 && fleet <= 4) {
          $(".js-teams-job-count-fleet")
            .text(fleet)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-fleet")
            .text(fleet)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (operations == 1) {
          $(".js-teams-job-count-operations")
            .text(operations)
            .siblings(".js-teams-single-job")
            .show();
        } else if (operations >= 2 && operations <= 4) {
          $(".js-teams-job-count-operations")
            .text(operations)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-operations")
            .text(operations)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (projects == 1) {
          $(".js-teams-job-count-projects")
            .text(projects)
            .siblings(".js-teams-single-job")
            .show();
        } else if (projects >= 2 && projects <= 4) {
          $(".js-teams-job-count-projects")
            .text(projects)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-projects")
            .text(projects)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (quality == 1) {
          $(".js-teams-job-count-quality")
            .text(quality)
            .siblings(".js-teams-single-job")
            .show();
        } else if (quality >= 2 && quality <= 4) {
          $(".js-teams-job-count-quality")
            .text(quality)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-quality")
            .text(quality)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (sales == 1) {
          $(".js-teams-job-count-sales")
            .text(sales)
            .siblings(".js-teams-single-job")
            .show();
        } else if (sales >= 2 && sales <= 4) {
          $(".js-teams-job-count-sales")
            .text(sales)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-sales")
            .text(sales)
            .siblings(".js-teams-multi-job")
            .show();
        }

        if (administrative == 1) {
          $(".js-teams-job-count-administrative")
            .text(administrative)
            .siblings(".js-teams-single-job")
            .show();
        } else if (administrative >= 2 && administrative <= 4) {
          $(".js-teams-job-count-administrative")
            .text(administrative)
            .siblings(".js-teams-middle-job")
            .show();
        } else {
          $(".js-teams-job-count-administrative")
            .text(administrative)
            .siblings(".js-teams-multi-job")
            .show();
        }

        $(".js-teams").addClass("c-teams--visible");
      }
    }
  })();

  // FRANCHISE STORIES SLICK

  if($('.js-colleagues-slick').length) {
    $('.js-colleagues-slick').slick({
      speed: 500,
      variableWidth:  true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      // adaptiveHeight: true,
      swipe: true,
      pauseOnHover: false,
      responsive: [{
        breakpoint: 1000,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  }

// REDIRECT Z /kuryr-formulár
  if ( window.location.href.includes('kuryr-formular') || window.location.href.includes('chci-byt-kuryr') ) {
    window.location.href = '/stan-se-kuryrem/';
  }
});

// SCROLL ON TOP OF VACANCY LIST
$(function () {

  const onScrollElement = $(".c-vacancy-list__text");

  $('.c-vacancy-list').on('click', '.cp-job__link' ,function (event) {

    $('html, body').animate({
      scrollTop: onScrollElement.offset().top + 80
    }, 'slow');

  });
});

const pageUrl = window.location.href;
const redirectButton = document.querySelector('.c-header__careers-link--rebrand');

if (pageUrl.includes('/dekujeme')) {

  redirectButton.addEventListener('click', (e)=>{
    e.preventDefault();
    window.location.href = '/stan-se-kuryrem/';
  });

}

// URL FILTER
const selectOffers = document.getElementById('offer-locations');

const addUrlFilter = (activeOption) => {
  activeOption.selectedOptions[0].id ?
      window.history.pushState('', 'Title', `/stan-se-kuryrem/?filter=${activeOption.selectedOptions[0].id}`) :
      window.history.pushState('', 'Title', '/stan-se-kuryrem/')
};

const setActiveOption = (urlFilterValue) => {
  selectOffers.options[urlFilterValue].setAttribute('selected', true);
  selectOffers.scrollIntoView({behavior: 'smooth'});
}

const checkUrlFilter = () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('filter')){
    setActiveOption(urlParams.get('filter'));
  }
}

const filterOffers = function () {
  const select = document.getElementById('offer-locations');
  const allOffers = Array.from( document.querySelectorAll('.c-bc-offers__offer') );
  allOffers.forEach( item => item.style.display = 'block' );

  const hiddenOffers = allOffers.filter( offer => !offer.children[0].children[2].innerText.includes(select.value));
  const viewOffers = allOffers.filter( offer => offer.children[0].children[2].innerText.includes(select.value));

  hiddenOffers.forEach( item => {
    item.style.display = 'none';
  });

  const textElement = document.querySelector('.o-text--pink');
  textElement.innerHTML = viewOffers.length;

  if (select.value === 'all') {
    allOffers.forEach( item => item.style.display = 'block' );
    textElement.innerHTML = allOffers.length;
  }

  addUrlFilter(select);
};

if (selectOffers) {
  selectOffers.addEventListener('change', filterOffers);
}

document.addEventListener('DOMContentLoaded', checkUrlFilter);
document.addEventListener('DOMContentLoaded', filterOffers);

